import { render, staticRenderFns } from "./custom-radio.vue?vue&type=template&id=2de307d2&scoped=true&"
import script from "./custom-radio.vue?vue&type=script&lang=js&"
export * from "./custom-radio.vue?vue&type=script&lang=js&"
import style0 from "./custom-radio.vue?vue&type=style&index=0&id=2de307d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de307d2",
  null
  
)

export default component.exports